module.exports = "<div class=\"<%= gwTileContentInside %>\" gw-partial=\"Item\"></div>\n"